(function () {
    'use strict';
    /*
     * Copyright (c) 2017-19 In Hand Health.
     * All rights reserved.
     */

    angular
        .module('ihh-common-web')
        .constant('CampaignGlanceConstants', {
            save: {
                errorString: 'We were unable to save the episode template glance tab.'
            },
            update: {
                errorString: 'We were unable to update the episode template glance tab.'
            },
            remove: {
                errorString: 'We were unable to remove the episode template glance tab.'
            }
        });
})();